<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addHotSearch">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        row-key="id"
        :data-source="table.data"
        style="width: 100%">
        <a-table-column
          data-index="value"
          title="搜索内容"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editHotSearch(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteHotSearch(record.id)">删除
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
:footer="null"
             title="热门搜索编辑"
             v-model="form.visible">
      <hotSearch-edit
        v-if="form.visible"
        :hot-search-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </hotSearch-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryHotSearchs,
  _deleteHotSearch,
} from '@/api/hotSearchApi';
import HotSearchEdit from './HotSearchEdit.vue';

async function getHotSearchList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryHotSearchs({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addHotSearch() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editHotSearch(hotSearchId) {
  this.form.data.id = hotSearchId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getHotSearchList();
}

async function deleteHotSearch(hotSearchId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteHotSearch(hotSearchId);
      this.$message.success('删除成功');
    },
  });
}

export default {
  name: 'HotSearchList',
  components: { HotSearchEdit },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'id',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getHotSearchList,
    deleteHotSearch,
    editHotSearch,
    addHotSearch,
    closeForm,
  },
  created() {
    this.getHotSearchList();
  },
};
</script>

<style scoped>

</style>
